module.exports = "/static/assets/da5eda28f6ce98ebf6c9ba47e5c52d50.png";